import * as ISchema from "#webapp/src/__schema__";
import { AvatarPerson } from "#webapp/src/components/avatar";
import { CalendarStatus } from "#webapp/src/components/calendar-status";
import { LogoClock } from "#webapp/src/components/logo";
import { H2 } from "#webapp/src/components/ui";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
import { fragments } from "./ProfileUserSummary.gql";
import * as s from "./ProfileUserSummary.styles";
import { IContainer, IProps, IState } from "./ProfileUserSummaryTypes";

class ProfileUserSummaryComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      toggled: false,
      sendingInvite: false,
      sentInvite: false,
    };
  }

  private getPerson() {
    if (this.props.org.personsByCalendarIdsErrorable.__typename === "GraphEntityError") {
      return null;
    }
    const personList = this.props.org.personsByCalendarIdsErrorable.list;
    if (!personList.length) {
      return null;
    }

    return personList[0];
  }

  private renderInviteStatus = (person: ISchema.IPerson | null) => {
    if (!person || person.isYou) {
      return <span />;
    }

    if (person.isUser) {
      return (
        <div style={s.joinLabel}>
          <LogoClock size={14} />
          <div style={{ marginLeft: 5 }}>{person.profile.givenName} is using Clockwise</div>
        </div>
      );
    }

    return null;
  };

  public render() {
    const { org, calendarId } = this.props;

    const person = this.getPerson();

    const calendarStatus =
      org.calendarStatusErrorable.__typename !== "GraphEntityError"
        ? org.calendarStatusErrorable
        : null;
    let profileTimeZone = null;
    if (
      org.profileTimeZonesErrorable.__typename !== "GraphEntityError" &&
      org.profileTimeZonesErrorable.list.length
    ) {
      profileTimeZone = org.profileTimeZonesErrorable.list[0];
    }

    const displayName =
      !!person && person.profile && person.profile.givenName && person.profile.familyName
        ? `${person.profile.givenName} ${person.profile.familyName}`
        : this.props.calendarId;

    return (
      <div style={s.container}>
        <AvatarPerson
          person={person}
          orgPerson={null}
          size="xlarge"
          backupCalendarId={calendarId}
          showUserBadge
        />
        <H2 style={s.title}>{displayName}</H2>
        <div style={s.email}>{calendarId}</div>
        <CalendarStatus
          calendarStatus={calendarStatus}
          profileTimeZone={profileTimeZone}
          person={person}
          calendarId={calendarId}
          column
        />
        <div style={{ ...s.btnContainer, marginTop: 12 }}>{this.renderInviteStatus(person)}</div>
      </div>
    );
  }
}

function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    calendarSelectionStates: state.webExtension.calendarSelectionStates,
  };
}

const reduxContainer = connect(mapStateToProps, {})(ProfileUserSummaryComponent);

export const ProfileUserSummary = createFragmentContainer<IContainer>(reduxContainer, fragments);
